<template>
    <PageFrame>
        <div>
            <h1>404, Whoops!</h1>
            <p>Seems like the page you are looking for is either missing or doesn't exist.</p>
            <p><router-link to="/">Back to jobs</router-link></p>
        </div>
    </PageFrame>
</template>

<script>
    import PageFrame from '@/components/PageFrame.vue'
    export default {
        name: "PageNotFound",
        components : {
            PageFrame
        }
    }
</script>
